<div class="d-flex flex-column gap-3" data-testid="invoices-panel">
  <div class="d-flex flex-column gap-1">
    <h3 class="av-section-title m-0">{{ 'backoffice.billing.invoices.title' | translate }}</h3>
    <p class="av-meta m-0">{{ 'backoffice.billing.invoices.advance_note' | translate }}</p>
    <p class="av-meta m-0" data-testid="invoices-actions-note">{{ 'backoffice.billing.invoices.actions_note' | translate }}</p>
    <a
      class="av-btn text-decoration-none align-self-start"
      [routerLink]="['/organizations', organizationId(), 'billing']"
      data-testid="billing-documents-link"
    >
      <mat-icon aria-hidden="true">receipt_long</mat-icon>
      <span>{{ 'backoffice.billing.documents.link' | translate }}</span>
    </a>
  </div>

  @switch (facade.invoicesState()) {
    @case ('error') {
      <av-empty-state
        icon="error_outline"
        [title]="'backoffice.billing.invoices.error_title' | translate"
        [message]="'backoffice.billing.invoices.error_message' | translate"
      ></av-empty-state>
    }
    @case ('ready') {
      <div class="filter-row d-flex flex-wrap align-items-end gap-2">
        <label class="d-flex flex-column gap-1" for="invoice-status">
          <span class="av-meta">{{ 'backoffice.billing.invoices.filters.status' | translate }}</span>
          <select
            id="invoice-status"
            class="av-field"
            [value]="facade.invoiceStatus()"
            (change)="filterStatus($any($event.target).value)"
          >
            <option value="">{{ 'backoffice.billing.invoices.filters.any_status' | translate }}</option>
            @for (option of statusOptions; track option) {
              <option [value]="option">{{ statusLabelKeys[option] | translate }}</option>
            }
          </select>
        </label>
      </div>

      @if (isEmpty()) {
        <av-empty-state
          icon="description"
          [title]="
            (facade.invoiceStatus()
              ? 'backoffice.billing.invoices.filtered_status_title'
              : 'backoffice.billing.invoices.empty_title'
            ) | translate
          "
          [message]="
            (facade.invoiceStatus()
              ? 'backoffice.billing.invoices.filtered_status_message'
              : 'backoffice.billing.invoices.empty_message'
            ) | translate
          "
        ></av-empty-state>
      } @else {
        <p class="av-meta m-0" data-testid="invoice-quantity-note">{{ 'backoffice.billing.invoices.quantity_note' | translate }}</p>

        <div class="table-scroll">
          <table class="av-table w-100" data-testid="invoice-table">
            <thead>
              <tr>
                <th scope="col">{{ 'backoffice.billing.invoices.table.invoice' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.invoices.table.status' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.invoices.table.plan' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.invoices.table.period' | translate }}</th>
                <th scope="col" class="text-end">{{ 'backoffice.billing.invoices.table.seats_short' | translate }}</th>
                <th scope="col" class="text-end">{{ 'backoffice.billing.invoices.table.devices_short' | translate }}</th>
                <th scope="col" class="text-end">{{ 'backoffice.billing.invoices.table.total' | translate }}</th>
              </tr>
            </thead>

            <tbody>
              @for (invoice of facade.invoices(); track invoice.id) {
                <tr>
                  <td class="av-source">{{ invoice.stripe_invoice_id || unresolved }}</td>

                  <td>
                    <av-status-chip
                      [label]="invoice.statusLabelKey | translate"
                      [tone]="invoice.statusTone"
                    ></av-status-chip>
                  </td>

                  <td class="cell-muted">{{ invoice.plan_name || unresolved }}</td>

                  <td class="cell-muted">
                    {{ invoice.period_start ? (invoice.period_start | date: dateFormat) : unresolved }}
                    —
                    {{ invoice.period_end ? (invoice.period_end | date: dateFormat) : unresolved }}
                  </td>

                  <td class="text-end">{{ invoice.seat_quantity ?? unresolved }}</td>

                  <td class="text-end">{{ invoice.device_quantity ?? unresolved }}</td>

                  <td class="text-end">
                    {{ invoice.total === null ? unresolved : (invoice.total | number: '1.2-2') }}
                    {{ invoice.currency || '' }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <av-paginator
          [page]="facade.invoicePage()"
          [pageSize]="facade.pageSize()"
          [total]="facade.invoiceTotal()"
          (pageChange)="goToPage($event)"
          (pageSizeChange)="changePageSize($event)"
        ></av-paginator>
      }
    }
    @default {
      <av-empty-state
        icon="hourglass_empty"
        [title]="'backoffice.billing.invoices.loading_title' | translate"
        [message]="'backoffice.billing.invoices.loading_message' | translate"
      ></av-empty-state>
    }
  }
</div>
